import { connect } from 'react-redux'
import WorkshiftJournalComponent from '../../components/invoice/workshiftJournal.component'
import { clearAttachWorkshiftJournalId } from '../../actions'

const mapStateToProps = (state) => {
  const workshift_journal = state.workShiftUser.workshift_journal

  const isEditInvoice = state.invoice.isEdit
  const invoiceEdit = state.invoice.invoiceEdit
  let edit_invoice_id = null
  if (invoiceEdit.length > 0) {
    edit_invoice_id = invoiceEdit[0].Invoice[0].invoice_id
  }
  let workshift_journal_filter
  if (isEditInvoice) {
    workshift_journal_filter = workshift_journal.filter(
      (el) => el.invoice_id === edit_invoice_id || el.invoice_id === null
    )
  }
  return {
    state,
    workshift_journal: workshift_journal_filter,
    workshift_journal_not_attached:
      state.workShiftUser.workshift_journal_not_attached
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    clearAttachWorkshiftJournalId: () =>
      dispatch(clearAttachWorkshiftJournalId())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkshiftJournalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkshiftJournalComponent)

export default WorkshiftJournalContainer
